import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RemoteManagerApiService {

  readonly remoteManagerUrl: string = 'configuration/remoteManager';

  constructor(private http: HttpClient) {}

  public getRemoteManagerConfiguration(): Observable<any> {
    return this.http.get(this.remoteManagerUrl);
  }

  public updateRemoteManagerConfiguration(configuration): Observable<any> {
    return this.http.put(this.remoteManagerUrl, configuration);
  }
}
